import { Stack } from 'expo-router';

import { primitive } from 'styles/constants/primitives';
import { isIos } from 'utils/environment';

import { App } from '../App';

export const unstable_settings = {
  initialRouteName: '(tabs)',
};

export default function RootLayout() {
  return (
    <App>
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: primitive.bk.$mayoEggWhite },
        }}
      >
        {/* this is like this and here not in (tabs) or (modals) so we can get the full screen no tabs look */}
        <Stack.Screen name="menu/section/[id]" options={{ presentation: 'card' }} />
        <Stack.Screen name="(tabs)" />
        <Stack.Screen
          name="(modals)"
          options={{
            // provides similar looking modal styles in conjunction with CardModal across OS types
            ...(isIos
              ? {
                  presentation: 'modal',
                }
              : {
                  presentation: 'transparentModal',
                  animation: 'slide_from_bottom',
                  contentStyle: { backgroundColor: 'transparent' },
                }),
          }}
        />
        <Stack.Screen
          name="(drawer)"
          options={{
            headerShown: false,
            animation: 'none',
            presentation: 'containedTransparentModal',
            contentStyle: { backgroundColor: 'transparent' },
          }}
        />

        <Stack.Screen
          name="campaigns/[campaignSlug]"
          options={{ presentation: 'fullScreenModal', animation: 'none' }}
        />

        {/**
         * Handles static pages, redirects, and true 404.
         *
         * NOTE: The none animation and transparent background are used
         * to prevent any visual effect during redirects (only visible
         * in release builds, not in debug!)
         *
         * NOTE: in the future we may be able to make this a "modal" presentation
         * when redirects are no longer used but right now it looks bad with a redirect
         */}
        <Stack.Screen
          name="+not-found"
          options={{
            animation: 'none',
            presentation: 'containedTransparentModal',
          }}
        />

        <Stack.Screen name="notification-inbox" />
        <Stack.Screen
          name="signout"
          options={{
            presentation: 'containedTransparentModal',
            animation: 'none',
          }}
        />
        <Stack.Screen
          name="noop"
          options={{
            presentation: 'containedTransparentModal',
            contentStyle: { backgroundColor: 'transparent' },
          }}
        />
      </Stack>
    </App>
  );
}
